import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import {DNA} from "@dna/react";

export const sharedUserInfoStyles = makeStyles((theme:Theme)=>createStyles({
    titleBig:{
        marginTop:"50px",
        fontSize: "40px",
        fontWeight: 600,
        lineHeight: "48px",
        letterSpacing: "-0.005em"
    },
    sectionTitle:{
        fontWeight:600,
        fontSize:"16px",
        marginTop:"41px",
        marginBottom:"16px"
    },
    textField: {
        marginBottom: '20px'
    },
    timelineTitle:{
        fontWeight:600,
        fontSize:"16px",
        marginBottom:"26px"
    },
    timelineContent:{
        display:"flex",
        flexDirection: "column"
    },
    timelineDot:{
        backgroundColor:"#EBF3FB !important"
    },
    errorLabel:{
        color: '#f44336',
        position: 'relative',
        bottom: '12px'
    },
  
    form:{
        display:"grid",
        minWidth: "620px",
        "& .submit":{
            backgroundColor:DNA.tokens.color.turquoise.mid,
        },
        "& .label":{
            fontSize:"20px",
        },
        marginTop:40,
        marginBottom:16
    },
    labelPadding:{
        paddingTop:8,
        paddingBottom:12,
        '& p': {
            color: '#f44336'
        },
    },
    timeLineItemRoot:{
        marginTop:"40px"
    },
    timelineRoot:{
        paddingLeft:0
    },
    missingOppositeContent:{
        "&:before": {
            display: "none"
        }
    },
    timelineConnector:{
      width:1,
      backgroundColor:"#D2D2D2" 
    },
    disclaimer:{
        marginLeft:27
    },
    backdrop:{
        zIndex: theme.zIndex.drawer + 1
    },
    textLabel: {
      fontSize: "15px",
      color: "rgba(0, 0, 0, 0.54)",
      fontFamily: "Source Sans Pro",
      marginTop:0,
      paddingTop:1,
      paddingBottom:12,
    }
}));